<template>
	<div id="juzucontent">
		<div class="container">
			<div class=" padding50">
				<div class="index-con-wd bk">
					<h2>基本信息<span class="change-sc el-icon-star-on" @click="addcollect(list.id)"><font style="font-size: 16px;margin-left: 10px;">{{collect}}</font></span></h2>
					<h4>BASIC INFORMATION</h4>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="float-left">
				<div class="juzu-base-p">
					<p>作品名称：{{list.movie_name}}</p>
					<p>作品类型：{{list.theme}}</p>
					<p>出品方：{{list.make}}</p>
					<p>筹备地点：{{list.prepare}}</p>
					<p>开机时间：{{list.start_time}}</p>
					<p>暂定拍摄地点：{{list.take_place}}</p>
					<p>暂定拍摄周期：{{list.take_period}}天</p>
					<p>作品简介：{{list.synopsis}}</p>
				</div>
			</div>
			<div class="float-right">
				<img :src="list.picture" width="300" height="440" alt="">
			</div>
			<div class="clearfix"></div>
			<div class="zf-con-five padding50">
				<ul>
					<li class="float-left" v-for="item in list.crew_post" :key="item.key">
						<img :src="item.images_url" width="220" height="330" :onerror="errorImg">
						<div class="zf-pic-foo3">
							<p>{{item.position}}：{{item.name}}</p>
							<p>代表作：{{item.representative}}</p>
						</div>
					</li>
					<div class="clearfix"></div>
				</ul>
				<div style="margin-top:100px ;"></div>
			</div>
			<div class=" padding50">
				<div class="index-con-wd bk">
					<h2>招募类型</h2>
					<h4>RECRUITMENT TYPE</h4>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="jz-zm" v-for="(item,key) in list.crew_recruit" :key="item.key">
				<div class="float-left jz-zm-num">
					{{key+1}}
				</div>
				<div class="float-left jz-zm-wd">
					<p>{{item.nature}}：{{item.role_name}}</p>
					<p>人物简介：{{item.synopsis}}</p>
				</div>
				<button class="float-left baoming" @click="baoming(item.id)">
					报名
				</button>
				<div class="clearfix"></div>
			</div>
			<div class=" padding50">
				<div class="index-con-wd bk">
					<h2>联系方式</h2>
					<h4> CONTATCT INFORMATION </h4>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="jz-zm" style="padding-top:10px" v-for="item in list.crew_contact" >
				
				<div class=" jz-zm-wd">
					<p><span class="font_2em">姓名</span>：{{item.name}}</p>
					<p><span class="font_3em">手机号</span>：{{item.mobile}}</p>
					<p><span class="font_qqem">qq号</span>：{{item.qqnumber}}</p>
					<p><span class="font_3em">微信号</span>：{{item.wechat}}</p>
					<p><span class="font_2em">邮箱</span>：{{item.mail}}</p>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
	import storage from '../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				errorImg: 'this.src="' + require('../assets/mrimg2.jpg') + '"', //未上传时显示默认图片
				list: [],
				rids: [],
				cid: '', //剧组id
				rid: '', //剧组角色id
				iden: '',
				collect:'加入收藏',//收藏状态默认内容
			}
		},
		methods: {
			requestData(id) { //路由传过来的uid
				var api = "https://api.yopoo.cn/api/v1/crewminute?id=" + id //剧组详细数据渲染接口
				this.$http.get(api).then((response) => {
						// console.log(response)
						this.list = response.body
					},
					err => {
						console.log(err)
					}
				)
			},
			addcollect(id) {
				var api = 'https://api.yopoo.cn/api/centre/collect?state=2&id=' + id //添加收藏接口
				var token = storage.get('token')
				if (token == null) {
					this.$message({
						message: '请先登录！',
						type: 'warning',
						center: true
					});
				} else {
					Axios.get(api).then((res) => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message({
								message: res.data.msg,
								type: 'success',
								center: true
							});
							this.collect='已收藏'
							$(function() {
								$('.el-icon-star-on').css('color', 'red')
							})
						}
						if (res.data.code == 202) {
							this.$message({
								message: res.data.msg,
								type: 'warning',
								center: true
							});
						}
					})
				}
			},
			baoming(rid) {
				let cid = this.$route.params.id;
				var iden = storage.get('iden')
				var token = storage.get('token')
				//剧组id获取
				if (iden == null && token == null) {
					this.$message({
						message: '请先登录！',
						type: 'warning',
						center: true
					});
				}
				if (iden == '2') {
					this.$message({
						message: '只有艺人与经纪人才可以报名！',
						type: 'warning',
						center: true
					});
				}
				if (iden == '1' || iden == '3') {
					var api = 'https://api.yopoo.cn/api/centre/gopraise?cid=' + cid + '&rid=' + rid //报名接口
					Axios.get(api).then((res) => {
						// console.log(res)

						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						});
					}).catch()
				}
			},
			testcollect(id) { //判断是否收藏
				var api = 'https://api.yopoo.cn/api/centre/selecollect?state=2&id=' + id //判断是否收藏接口
				// var token = storage.get('token')

				this.$http.get(api).then((res) => {
					// console.log(res.data)
					if (res.data == 1) { //判断res.data的值，为1的时候是已收藏，然后修改样式
						this.collect='已收藏'
						$(function() {
							$('.el-icon-star-on').css('color', 'red')
						})
					}
				})
			}
		},
		metaInfo() {
			return {
				title: this.list.movie_name || '',
				meta: [{
					name: 'keywords',
					content: ''
				},
					{
						name: 'description',
						content: ''
					}
				]
			}
		},
		mounted() {
			var id = this.$route.params.id;
			this.requestData(id)
			this.testcollect(id)
		}
	}
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/JuzuContent.vue